import React from "react";
import {
  Paper,
  Grid,
  Typography,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Link,
  Box,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Image from "material-ui-image";
import { getDate } from "../../utils/date";

export const ReportCard = ({ report }) => {
  const classes = useStyles();
  return (
    <>
      <Paper className={classes.root}>
        <Accordion elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={classes.accordionSummary}
            IconButtonProps={{ className: classes.expendIcon }}
          >
            <Grid container direction="row" alignItems="center">
              <Grid item md={5}>
                <Image
                  src={report.topimage}
                  alt="thambnail"
                  style={{ paddingTop: 0, position: "unset" }}
                  imageStyle={{
                    height: "unset",
                    width: "unset",
                    maxHeight: "100px",
                    maxWidth: "100px",
                    borderRadius: "6px",
                    margin: "10px",
                  }}
                  disableSpinner
                />
              </Grid>
              <Grid item md={7} className={classes.cardContent}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  className={classes.container}
                  justify="space-between"
                >
                  <Grid item md={12}>
                    <Typography className={classes.title} component="div">
                      <Link
                        href={report.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                      >
                        <Box
                          textOverflow="ellipsis"
                          component="div"
                          className={classes.titleText}
                        >
                          {report.headline}
                        </Box>
                      </Link>
                    </Typography>
                  </Grid>
                  <Grid item md={12}>
                    <Typography>{report.source.name}</Typography>
                  </Grid>
                  <Grid item md={12} className={classes.date}>
                    <Box pt={1} mb={1}>
                      <Typography className={classes.dateText}>
                        {getDate(report.date)}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails className={classes.detail}>
            <List className={classes.list}>
              {report.snippets.map((snippet) => (
                <ListItem key={snippet.text} button>
                  <Typography>{snippet.text}</Typography>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </Paper>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "3px 3px 30px rgba(0, 0, 0, 0.15)",
    paddingBottom: "10px ",
  },
  image: {
    height: "100px",
    width: "100px",
    borderRadius: "6px",
    margin: "10px",
  },
  container: {
    height: "100px",
  },
  cardContent: {
    height: "100%",
  },
  accordionSummary: {
    // flexDirection: "row-reverse",
    padding: 0,
  },
  expendIcon: {
    marginRight: 0,
  },
  detail: {
    padding: "0px 10px 0px",
  },
  title: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "19px",
    // margin: "10px 0",
    "& a ": {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "19px",
      color: theme.palette.text.primary,
    },
    "& a:hover": {
      color: theme.palette.text.primary,
      textDecoration: "none",
    },
  },
  titleText: {
    height: "55px",
    // whiteSpace: "nowrap",
    display: "block",
    overflow: "hidden",
  },
  date: {
    display: "flex",
    justifyContent: "flex-end",
  },
  dateText: {
    color: theme.palette.text.secondary,
    fontSize: "12px",
    lineHeight: "12px",
  },
}));
